

import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import {
    VerificationService,
    assertValidSegmentName,
    SegmentEnum,
    SubSegmentEnum,
} from '@sheerid/jslib';


interface Props {
    verificationService: VerificationService;
}

const UploadInfoComponent: React.SFC<Props> = ({ verificationService }) => {
    const { segment } = verificationService.verificationResponse;
    const { subSegment } = verificationService.verificationResponse;
    assertValidSegmentName(segment);

    switch (segment) {
        case SegmentEnum.MEMBER:
            return (
                <div>
                    <span className="sid-upload-info-header">
                        <FormattedMessage
                            id="step.docUpload.uploadInstructions"
                            defaultMessage="Upload an official document that shows:"
                        />
                    </span>

                    <div className="sid-l-space-top-md" />

                    <FormattedHTMLMessage
                        id="step.docUpload.stateDepartment.governmentIssued"
                        defaultMessage="This should be a typical government-issued document. It must include:"
                    />

                    <ul className="sid-upload-info-list sid-l-space-top-md">
                        <li className="sid-upload-info-list__li">
                            <FormattedMessage
                                id="step.docUpload.uploadInfo.fullName"
                                defaultMessage="Your full name"
                            />
                        </li>
                        <li className="sid-upload-info-list__li">
                            <FormattedMessage
                                id="step.docUpload.uploadInfo.stateDepartment.currentEmployment"
                                defaultMessage="Your current employment with the State Department"
                            />
                        </li>
                        <li className="sid-upload-info-list__li">
                            <FormattedMessage
                                id="step.docUpload.uploadInfo.servingAbroad"
                                defaultMessage="Indication that you're serving abroad"
                            />
                        </li>
                    </ul>
                </div>
            );
        case SegmentEnum.MILITARY:
            switch (subSegment) {
                case SubSegmentEnum.MILITARY_FAMILY:
                    return (
                        <div>
                            <span>
                                <strong>
                                    <FormattedMessage
                                        id="step.docUpload.uploadInfo.military.uploadInstructionsDependent"
                                        defaultMessage="Please upload a document that clearly shows
                                            your first name, last name, valid dates and status"
                                    />
                                </strong>
                            </span>
                        </div>
                    );
                default:
                    return (
                        <div>
                            <span className="sid-upload-info-header">
                                <FormattedMessage
                                    id="step.docUpload.uploadInstructions"
                                    defaultMessage="Upload your government-issued document that shows:"
                                />
                            </span>

                            <div className="sid-l-space-top-md" />

                            <FormattedHTMLMessage
                                id="step.docUpload.military.governmentIssued"
                                defaultMessage="This should be a typical government-issued document (such as orders or deployment papers). It must include:"
                            />

                            <ul className="sid-upload-info-list sid-l-space-top-md">
                                <li className="sid-upload-info-list__li">
                                    <FormattedMessage
                                        id="step.docUpload.uploadInfo.fullName"
                                        defaultMessage="Your full name"
                                    />
                                </li>
                                <li className="sid-upload-info-list__li">
                                    <FormattedMessage
                                        id="step.docUpload.uploadInfo.military.serviceBranch"
                                        defaultMessage="Your branch of service"
                                    />
                                </li>
                                <li className="sid-upload-info-list__li">
                                    <FormattedMessage
                                        id="step.docUpload.uploadInfo.military.currentAffiliation"
                                        defaultMessage="Your current affiliation with the armed services"
                                    />
                                </li>
                                <li className="sid-upload-info-list__li">
                                    <FormattedMessage
                                        id="step.docUpload.uploadInfo.servingAbroadMilitary"
                                        defaultMessage="Proof that you're stationed outside of the United States"
                                    />
                                </li>
                                <li className="sid-upload-info-list__li sid-duty-station">
                                    <FormattedMessage
                                        id="step.docUpload.uploadInfo.dutyStation"
                                        defaultMessage="Duty Station"
                                    />
                                </li>
                            </ul>
                            <span> 
                                    <FormattedMessage
                                        id="step.docUpload.uploadInfo.speedUp"
                                        defaultMessage="To speed up the review process, we recommend highlighting this information on the uploaded files."
                                    />
                            </span>
                        </div>
                    );
            }
        default:
            return null;
    }
};

export { UploadInfoComponent };
